<div class="card h-100 card-no-border mt-4">
    <div class="card-body no-padding">
        <cfg-table [resource]="synchronizationsResource" [columns]="columns" [trackBy]="trackById"
            [searchFields]="['name', 'customerName', 'companyName', 'customerId', 'companyId']"
            searchParam="search" searchStorageKey="synchronizations"
            searchPlaceholder="Søg synkroniseringer..." [defaultSort]="defaultSort" [rowLink]="rowLink"
            emptyText="Ingen synkroniseringer at vise." loadingText="Indlæser synkroniseringer"
            errorText="Fejl under indlæsning af synkroniseringer.">

            <!-- Ændret vises formateret; sortering sker på den rå dato via kolonnens key -->
            <ng-template cfgCell="changed" [cfgCellOf]="synchronizationsResource.value()" let-row>
                {{ row.changed | date:'dd-MM-yyyy HH:mm:ss' }}
            </ng-template>
        </cfg-table>
    </div>
</div>
